import { Box, Stack, Typography, useTheme } from '@mui/material'
import kyivstarIcon from 'assets/icons/kyivstar.png'

const phoneList = [
  { icon: kyivstarIcon, text: '(067)435-52-13' },
  { icon: kyivstarIcon, text: '(050)245-67-55' },
  { icon: kyivstarIcon, text: '(063)333-33-33' },
]

export const Contacts = () => {
  const theme = useTheme()

  return (
    <Box>
      {phoneList.map(({ icon, text }) => (
        <Stack key={text} direction="row" spacing={0.5}>
          <img
            src={icon}
            style={{ width: '14px', height: '14px' }}
            alt="operator icon"
          />
          <Typography
            variant="body2"
            fontWeight={700}
            lineHeight="14px"
            color={theme.palette.text.primary}
            sx={{ textWrap: 'nowrap' }}
          >
            {text}
          </Typography>
        </Stack>
      ))}
    </Box>
  )
}
